module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/pepsidiginday-bg-de2b8a9ae5122849d7064221b5a6d149.png";